import { Observable } from '../Observable';
export function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return function (source) {
        return new Observable(function (subscriber) {
            subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
        });
    };
}
//# sourceMappingURL=subscribeOn.js.map